import React, { useState, useEffect } from "react";
import Container from "../../components/Container";
import Router from "next/router";
// import CouponBox from "./RegistrationComponents/CouponBox";
import RegistrationBox from "../Checkout/RegistrationComponents/RegistrationBox";
import CouponBox from "../Checkout/RegistrationComponents/SubComponents/CartBox/CouponBox";
import { getEventDetails, getEventTickets, getWaitlist } from "../../crud/checkout.crud";
import { errorToaster, encodeTicketFormNames } from "../../helpers/utils";
import TippyIcon from "../../components/TippyIcon";
import { checkTeamBasedRegStatus, convertTimezone } from "../../helpers/common";
import moment from "moment-timezone";
import { baseUrl } from "../../config/config";
import RegistrationTimer from "../Checkout/RegistrationComponents/SubComponents/RegistrationTimer";
import { TinyColor } from "@ctrl/tinycolor";
import { motion } from "framer-motion";
import TicketExpired from "../Checkout/RegistrationComponents/SubComponents/TicketExpired";

const Widget = ({ query, isReady }) => {
	const [eventDetails, setEventDetails] = useState("");
	const [ticketDetails, setTicketDetails] = useState("");
	const [groupDiscounts, setGroupDiscounts] = useState([]);
	const [totalActiveRegs, setTotalActiveRegs] = useState(0);
	const [ticketExpired, setTicketExpired] = useState(false); // 0 -> is not expired, 1 -> expired, 2 -> access code purchased, 3 -> coming soon
	const [waitlistDetails, setWaitlistDetails] = useState("");
	const [curComp, setCurComp] = useState(0);
	const [isBackClicked, setIsBackClicked] = useState(false);
	const [openPaymentModal, setOpenPaymentModal] = useState(false);
	const [selectedTickets, setSelectedTickets] = useState([]); // Getting the tickets for registration timer
	const [teamRegStatus, setTeamRegStatus] = useState(0); // 0 -> No team based tickets, 1 -> Only team based tickets, 2 -> team based and individual tickets
	const [teamRegType, setTeamRegType] = useState(false); //false -> not selected, 0 -> individual tickets, 1 -> Create team, 2 -> Join Team
	const [isLoading, setIsLoading] = useState(true);
	const [formRules, setFormRules] = useState("");
	const [isEventPageTeamComp, setIsEventPageTeamComp] = useState(false);

	useEffect(() => {
		if (isReady && query.eventUrl)
			fetchDetails(query.eventUrl, query.booking_id, query.referred_by);
		else if (isReady && !query.eventUrl) Router.push("/error");
		setIsEventPageTeamComp(sessionStorage.getItem("isEventPageTeamComp") ? true : false);
	}, [query, isReady]);

	const fetchDetails = async (url, bookingId, referred_by) => {
		const isReferral = referred_by ? true : false;
		const error = "Something went wrong, please try again later";
		try {
			const eventRes = await getEventDetails(url);
			if (eventRes.status === 200) {
				setEventDetails(eventRes.data);
				// setCurComp(query.singleReg ? 1 : 0)
				let waitlistTicket = false;
				if (bookingId) {
					waitlistTicket = await getWaitlistDetails(url, bookingId);
				}
				await getTicketDetails(url, waitlistTicket, isReferral);
			} else {
				Router.push("/error/404");
			}
		} catch (err) {
			errorToaster(error);
		}
	};

	const getTicketDetails = async (url, waitlistTicket, isReferral) => {
		const error = "Something went wrong, please try again later";
		try {
			setIsLoading(true);
			const ticketRes = await getEventTickets(url, isReferral);
			setGroupDiscounts(ticketRes.data.group_discount_details);
			setTotalActiveRegs(
				ticketRes.data.total_active_registrations
					? ticketRes.data.total_active_registrations
					: 0
			);
			const uncategorized = ticketRes.data.uncategorized;
			let ticketDetails = [...uncategorized];
			ticketRes.data.categorized = ticketRes.data.categorized.sort(
				(a, b) => a.category_order - b.category_order
			);
			ticketRes.data.categorized.forEach(category => {
				category.tickets = category.tickets.map(ticket => {
					ticket.category = {
						category_name: category.category_name,
						category_description: category.category_description,
						category_id: category.category_id,
						category_order: category.category_order,
						is_expanded: category.is_expanded
					};
					return ticket;
				});
				ticketDetails = [...ticketDetails, ...category.tickets];
			});
			// let ticketDetails = ticketRes.data.uncategorized;
			ticketDetails.forEach(ticket => {
				ticket.final_price = ticket.ticket_price;
				if (
					waitlistTicket && //If waitlist is approved, add a field to recognize in ticketSummary.js for payment button
					ticket.waitlist_enabled &&
					waitlistTicket.ticket_id === ticket.ticket_id
				) {
					ticket.waitlist_done = true;
				}
			});

			if (query.tickets) {
				const selectedTicketsId = query.tickets.split(",");
				const newTickets = ticketDetails.filter((ticket, i) =>
					selectedTicketsId.includes(ticket.ticket_id.toString())
				);
				const teamRegistrationStatus = checkTeamBasedRegStatus(newTickets);
				if (teamRegistrationStatus > 0) checkIfTeamSelected(teamRegistrationStatus);
				setTeamRegStatus(teamRegistrationStatus);
				setTicketDetails(encodeTicketFormNames(newTickets));
				setFormRules(ticketRes.data.form_rules);
			} else {
				const teamRegistrationStatus = checkTeamBasedRegStatus(ticketDetails);
				if (teamRegistrationStatus > 0) checkIfTeamSelected(teamRegistrationStatus);
				setTeamRegStatus(teamRegistrationStatus);
				setTicketDetails(encodeTicketFormNames(ticketDetails));
				setFormRules(ticketRes.data.form_rules);
			}
			setIsLoading(false);
		} catch (err) {
			console.log(err);
			errorToaster(error);
			setIsLoading(false);
		}
	};

	const checkIfTeamSelected = teamRegistrationStatus => {
		if (teamRegistrationStatus) {
			const teamName = sessionStorage.getItem("team_name");
			const teamId = sessionStorage.getItem("team_id");
			const teamLeadName = sessionStorage.getItem("team_lead_name");
			const teamLeadEmail = sessionStorage.getItem("team_lead_email");
			if (query.team_name && query.team_id) {
				if (!!teamName && !!teamId) {
					setTeamRegType(2);
					setCurComp(0);
				} else setCurComp(3);
			} else if (query.team_name && query.team_lead_email && query.team_lead_name) {
				if (!!teamName && !!teamLeadName && !!teamLeadEmail) {
					setTeamRegType(1);
					setCurComp(0);
				} else setCurComp(3);
			} else if (query.teamRegType === "0") {
				setTeamRegType(0);
				setCurComp(0);
			} else {
				setCurComp(3);
			}
		}
	};

	const getWaitlistDetails = async (eventUrl, bookingId) => {
		const error = "Something went wrong, please try again later";
		try {
			const waitlistRes = await getWaitlist(eventUrl, bookingId);
			const waitlistDetails = waitlistRes.data.message.waitlist_details;
			setWaitlistDetails(waitlistDetails);
			return waitlistDetails;
		} catch (err) {
			console.log(err);
			setTicketExpired(2);
			// errorToaster(error);
		}
	};

	const getCouponDetails = (couponDetails, coupon) => {
		// setTicketDetails
		const newTicketDetails = [...ticketDetails];
		const couponTickets = couponDetails.applicable_tickets;
		newTicketDetails.forEach(ticket => {
			const ticketPrice = ticket.ticket_price;
			ticket.final_price = ticketPrice;
			ticket.discount = null;
			ticket.discount_remaining = null;
			if (couponTickets.includes(ticket.ticket_id)) {
				ticket.discount = couponDetails.discount;
				let finalPrice;
				if (couponDetails.discount_type === 1) {
					finalPrice = ticketPrice - ticket.discount;
					ticket.final_price = finalPrice;
				} else if (couponDetails.discount_type === 2) {
					finalPrice = ticketPrice - ticketPrice / ticket.discount;
					ticket.final_price = finalPrice;
				}
				if (finalPrice <= 0) {
					ticket.final_price = 0;
				}
			}
		});
		// if coupon code is unlimited set limit as Infinity
		const couponCodeLim = couponDetails.remaining ? couponDetails.remaining : Infinity;
		setIsNewCode(true);
		setCouponCodeLimit(couponCodeLim);
		setCouponInitialLimit(couponCodeLim);
		setCouponCode(coupon);
		setTicketDetails(newTicketDetails);
	};

	const removeCoupon = () => {
		const newTicketDetails = [...ticketDetails];
		newTicketDetails.forEach(ticket => {
			ticket.final_price = ticket.ticket_price;
			ticket.discount = null;
			ticket.discount_remaining = null;
		});
		setTicketDetails(newTicketDetails);
		setCouponCode("");
		setCouponCodeLimit(null);
		setCouponInitialLimit(null);
	};

	useEffect(() => {
		// Load google ticket-sub-texts
		const isServer = () => typeof window === "undefined";
		if (!isServer()) {
			import("webfontloader").then(WebFont => {
				if (isReady && query.fontFamily) {
					WebFont.load({
						google: {
							families: [`${query.fontFamily}:200,400,500,600`]
						}
					});
				}
			});
		}
	}, [query, isReady]);

	// useEffect(() => {
	//     if(eventDetails && ticketDetails) {
	//         addConsentToForms(ticketDetails, eventDetails.consents)
	//     }
	// }, [ticketDetails, eventDetails]);

	const handleBackBtn = () => {
		switch (curComp) {
			case 0:
				if (teamRegStatus === 0) Router.push(`${baseUrl}/${eventData.event_url}`);
				else {
					setCurComp(3);
					setTeamRegType(false);
				}
				break;
			case 1:
				// setCurComp(0);
				setIsBackClicked(true);
				break;
			case 2:
				setCurComp(1);
				break;
			case 3:
				Router.push(`${baseUrl}/${eventData.event_url}`);
				break;
			default:
				break;
		}
	};

	const timeZone = eventDetails.time_zone;
	const event_start_timestamp = convertTimezone(
		`${eventDetails.start_date} ${eventDetails.start_time}`,
		timeZone
	);
	const event_end_timestamp = convertTimezone(
		`${eventDetails.end_date} ${eventDetails.end_time}`,
		timeZone
	);

	const date = {
		start_month: moment(event_start_timestamp).format("Do MMM"),
		end_month: moment(event_end_timestamp).format("Do MMM"),
		start_day: moment(event_start_timestamp).format("ddd"),
		end_day: moment(event_end_timestamp).format("ddd"),
		start_year: moment(event_start_timestamp).format("YYYY"),
		end_year: moment(event_start_timestamp).format("YYYY"),
		start_time: moment(event_start_timestamp).format("h:mm A"),
		end_time: moment(event_end_timestamp).format("h:mm A"),
		timezone: moment.tz(event_start_timestamp, eventDetails.time_zone).format("z")
	};

	return (
		<>
			{ticketExpired == 0 ? (
				<div className="widget-container">
					<div className="container-fluid widget-con-outer px-md-3 px-lg-3 px-xl-5 px-sm-0">
						<div className="row mx-0">
							<div className="col-sm-12 col-md-12 no-padding">
								<div className="widget-header-container d-none d-md-block">
									{curComp !== 0 && curComp !== 3 && (
										<div className="d-flex justify-content-between mt-4">
											<motion.button
												whileHover={{ scale: 1.08 }}
												className="d-md-flex d-none ps-0 p-3 no-button-outline back-btn-checkout-mobile align-items-center"
												onClick={handleBackBtn}
											>
												<i className="fas fa-chevron-left mobile-back-btn"></i>{" "}
												<span className="ms-2 back-btn-widget">
													Go back
												</span>
											</motion.button>
											<RegistrationTimer
												url={`${baseUrl}${Router.router.asPath}`}
												query={{}}
												eventDetails={eventDetails}
												selectedTickets={selectedTickets}
												className="d-inline-block align-item-center timer-count widget-time-counter mt-auto px-2 pt-1"
											/>
										</div>
									)}
								</div>
								<RegistrationBox
									eventDetails={eventDetails}
									ticketDetails={ticketDetails}
									setTicketExpired={setTicketExpired}
									setTicketDetails={setTicketDetails}
									query={query}
									groupDiscounts={groupDiscounts}
									totalActiveRegs={totalActiveRegs}
									waitlistDetails={waitlistDetails}
									curComp={curComp}
									setCurComp={setCurComp}
									isWidget={true}
									isLoading={isLoading}
									isBackClicked={isBackClicked}
									setIsBackClicked={setIsBackClicked}
									setSelectedTickets={setSelectedTickets}
									handleBackBtn={handleBackBtn}
									openPaymentModal={openPaymentModal}
									setOpenPaymentModal={setOpenPaymentModal}
									getTicketDetails={getTicketDetails}
									teamRegStatus={teamRegStatus}
									teamRegType={teamRegType}
									setTeamRegType={setTeamRegType}
									formRules={formRules}
									setFormRules={setFormRules}
									isEventPageTeamComp={isEventPageTeamComp}
									setIsEventPageTeamComp={setIsEventPageTeamComp}
								/>
							</div>
						</div>
					</div>
					<style jsx global>{`
						body {
							background: ${query.bg
							? `#${query.bg} !important`
							: "#ffffff !important"};
							font-family: ${query.fontFamily
							? `${query.fontFamily} !important`
							: "Prompt, sans-serif !important"};
						}
						.back-btn-cont {
							width: 115px;
						}
						.widget-container {
							background: ${query.bg ? `#${query.bg}` : "#fff"};
						}
						.widget-time-counter {
							margin-bottom: 16px;
						}
						.bg-1 {
							background: url("/img/checkout/checkout-bg-1.svg") no-repeat;
							position: absolute;
							background-position: top left 15%;
							z-index: 0;
						}
						.bg-2 {
							background: url("/img/checkout/checkout-bg-2.svg") no-repeat;
							position: absolute;
							background-position: bottom -60px right 50px;
							z-index: 0;
						}
						.event-page-title-cont {
							color: ${query.cl ? `#${query.cl}` : "#212529"};
						}
						.back-btn-checkout-mobile {
							background: transparent;
						}
						.no-button-outline {
							border: none;
							outline: none;
						}
						.event-page-btn {
							border-radius: 100%;
							width: 60px;
							height: 60px;
							transition: 0.3s all;
							background: ${query.btnCl ? `#${query.btnCl}` : "transparent"};
							border: 1px solid ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
						}

						.back-btn-widget {
							font-size: 16px;
							font-weight: 600;
							color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
						}

						.event-page-btn:hover {
							background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
						}

						.widget-header-container {
							height: 60px;
						}

						.desktop-back-btn {
							color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
							font-size: 28px;
						}

						.mobile-back-btn {
							color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
							font-size: 28px;
						}

						.event-page-btn:hover .desktop-back-btn,
						.event-page-btn:hover .mobile-back-btn {
							color: ${query.btnCl ? `#${query.btnCl}` : "#fff"};
						}

						.widget-con-outer {
							padding-right: 1rem;
							padding-left: 1rem;
						}

						.header-sm-container .header-sub-text,
						.icons-container .header-sub-text {
							color: ${query.fontColor ? `#${query.fontColor}` : "auto"} !important;
						}

						.cart-btn {
							background: ${query.btnColor
							? `#${query.btnColor}`
							: "auto"} !important;
						}

						@media (min-width: 768px) and (max-width: 991px) {
							.timer-count-container {
								width: 100%;
								margin-top: 1rem !important;
							}
						}

						@media (max-width: 768px) {
							.widget-con-outer,
							.no-padding {
								padding-right: 0rem;
								padding-left: 0rem;
							}

							.widget-container {
								height: auto;
								background: ${query.secondaryBg ? `#${query.secondaryBg}` : `#fff`};
								color: ${query.fontColor ? `#${query.fontColor}` : "auto"};
							}
							.bg-2 {
								display: none;
							}
							.bg-1 {
								background-size: contain;
							}
							.widget-header-container {
								height: 50px;
							}
							.event-title-bg {
								background: ${query.bg ? `#${query.bg}` : "#fff"};
								border-radius: 10px;
								width: 95%;
							}
						}
					`}</style>
				</div>
			) : (
				<TicketExpired
					type={ticketExpired}
					eventName={eventDetails.name}
					eventTemplate={eventDetails.event_template}
					goBack={() => {
						window.location.href = `${baseUrl}/widget/${Router.router.query.eventUrl}`;
					}}
				/>
			)}
		</>
	);
};

export default Widget;
